module.exports = __webpack_public_path__ + "static/svc-img-1-39b4507108e72596884abb87a3f1f82b.jpeg";